import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hizmetler, kategoriler } from '@/mocks/hizmetler';
import HizmetKart from './components/HizmetKart';

export default function HizmetlerPage() {
  const [aktifKategori, setAktifKategori] = useState('Tümü');
  const [mobileMenu, setMobileMenu] = useState(false);

  const filtrelenmis = aktifKategori === 'Tümü'
    ? hizmetler
    : hizmetler.filter((h) => h.kategori === aktifKategori);

  return (
    <div className="min-h-screen" style={{ background: '#1A0F0A', fontFamily: "'Inter', sans-serif" }}>
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;1,700;1,800&family=Inter:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/10"
        style={{ background: 'rgba(26,15,10,0.95)', backdropFilter: 'blur(16px)' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-[68px]">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/a5d1b8cb-aaa2-4cf9-95cd-76f3854cad51.png"
              alt="Elora Beauty Lounge"
              className="h-9 w-auto object-contain"
            />
          </Link>
          <div className="hidden md:flex items-center gap-7">
            <Link to="/" className="text-sm text-white/60 hover:text-[#E8B86D] transition-colors">Ana Sayfa</Link>
            <Link to="/hizmetler" className="text-sm text-[#E8B86D] font-semibold relative after:absolute after:bottom-[-4px] after:left-0 after:right-0 after:h-px after:bg-[#E8B86D]">Hizmetler</Link>
            <Link to="/#kampanyalar" className="text-sm text-white/60 hover:text-[#E8B86D] transition-colors">Kampanyalar</Link>
            <Link to="/#final-cta" className="text-sm text-white/60 hover:text-[#E8B86D] transition-colors">İletişim</Link>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://wa.me/905001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#1A0F0A] text-sm font-black px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap hidden md:block"
              style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
            >
              Randevu Al
            </a>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center text-white/70 cursor-pointer"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              <i className={mobileMenu ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
        {mobileMenu && (
          <div className="md:hidden border-t border-white/10 px-6 py-4 space-y-3"
            style={{ background: 'rgba(26,15,10,0.98)' }}>
            <Link to="/" className="block text-sm text-white/70 py-2" onClick={() => setMobileMenu(false)}>Ana Sayfa</Link>
            <Link to="/hizmetler" className="block text-sm text-[#E8B86D] font-semibold py-2" onClick={() => setMobileMenu(false)}>Hizmetler</Link>
            <Link to="/#kampanyalar" className="block text-sm text-white/70 py-2" onClick={() => setMobileMenu(false)}>Kampanyalar</Link>
            <Link to="/#final-cta" className="block text-sm text-white/70 py-2" onClick={() => setMobileMenu(false)}>İletişim</Link>
          </div>
        )}
      </nav>

      {/* Hero Banner */}
      <div className="relative pt-[68px]">
        <div className="relative h-64 md:h-80 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=luxury%20beauty%20salon%20interior%20elegant%20dark%20moody%20atmosphere%20gold%20accents%20professional%20skincare%20clinic%20premium%20aesthetic%20wide%20panoramic%20shot%20warm%20dim%20lighting%20marble%20surfaces&width=1400&height=500&seq=hizpage002&orientation=landscape"
            alt="Hizmetlerimiz"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(26,15,10,0.75) 0%, rgba(26,15,10,0.45) 60%, rgba(26,15,10,0.3) 100%)' }} />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <span className="inline-block px-4 py-1.5 text-[#E8B86D] text-xs font-medium tracking-widest uppercase rounded-full mb-4 border border-[#E8B86D]/30"
              style={{ background: 'rgba(232,184,109,0.1)' }}>
              Premium Güzellik Hizmetleri
            </span>
            <h1
              className="font-black italic text-white mb-3 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}
            >
              Hizmetlerimiz
            </h1>
            <p className="text-white/60 text-sm md:text-base max-w-lg font-light">
              Uzman ekibimiz ve son teknoloji cihazlarımızla size özel güzellik deneyimi
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4">
        <div className="flex items-center gap-2 text-xs text-white/30">
          <Link to="/" className="hover:text-[#E8B86D] transition-colors cursor-pointer">Ana Sayfa</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-[#E8B86D]/80 font-medium">Hizmetler</span>
        </div>
      </div>

      {/* Kategori Filtresi */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pb-8">
        <div className="flex flex-wrap gap-2">
          {kategoriler.map((kat) => (
            <button
              key={kat}
              onClick={() => setAktifKategori(kat)}
              className="px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap border"
              style={
                aktifKategori === kat
                  ? { background: 'linear-gradient(135deg, #C9943A, #E8B86D)', color: '#1A0F0A', borderColor: 'transparent', fontWeight: 700 }
                  : { background: 'rgba(255,255,255,0.04)', color: 'rgba(255,255,255,0.55)', borderColor: 'rgba(255,255,255,0.12)' }
              }
            >
              {kat}
            </button>
          ))}
        </div>
      </div>

      {/* Hizmet Kartları */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pb-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtrelenmis.map((hizmet) => (
            <HizmetKart key={hizmet.id} hizmet={hizmet} />
          ))}
        </div>

        {filtrelenmis.length === 0 && (
          <div className="text-center py-20 text-white/30">
            <i className="ri-search-line text-4xl mb-3 block"></i>
            <p>Bu kategoride henüz hizmet bulunmuyor.</p>
          </div>
        )}
      </div>

      {/* Alt CTA Bandı */}
      <div className="py-14 px-6 border-t border-white/10" style={{ background: 'rgba(255,255,255,0.03)' }}>
        <div className="max-w-3xl mx-auto text-center">
          <h2
            className="font-black italic text-white mb-3 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.6rem, 3vw, 2.4rem)' }}
          >
            Hangi Hizmet{' '}
            <span style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Size Uygun?
            </span>
          </h2>
          <p className="text-white/45 text-sm mb-8 font-light">
            Uzmanlarımız ücretsiz danışmanlık ile size en uygun uygulamayı belirliyor
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://wa.me/905001234567?text=Merhaba, hizmetler hakkında bilgi almak istiyorum."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-[#1ebe5d] transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp&apos;tan Yaz
            </a>
            <Link
              to="/#final-cta"
              className="inline-flex items-center justify-center gap-2 text-[#1A0F0A] px-7 py-3.5 rounded-full font-black text-sm transition-all whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
            >
              <i className="ri-calendar-line text-lg"></i>
              Randevu Talep Et
            </Link>
          </div>
        </div>
      </div>

      {/* Footer mini */}
      <div className="py-5 px-6 text-center border-t border-white/10">
        <p className="text-white/25 text-xs">
          © 2024 Elora Beauty Lounge — Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  );
}
